export type LetterCategory = {
  id: number;
  name: string;
};

export const DocumentType = {
  Letter: 'L',
  Policy: 'P',
} as const;
export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export type Letter = {
  assetID: string;
  authorName: string;
  categoryName: string;
  categorySortOrder: number;
  countryId: number;
  dateSubmitted: string;
  publishedByUserFullName: string;
  publishedOn: string;
  referenceNumber: string;
  versionNumber?: string;
  retiredByUserFullName?: string;
  retiredOn?: string;
  statusKey: number;
  statusId?: number;
  statusName: string;
  title: string;
};

export type LetterDetail = {
  assetID: string;
  authorName: string;
  canBeDownloaded: boolean;
  categoryID: number;
  categoryName: string;
  countryId: number;
  createdOn?: string;
  data?: string;
  description?: string;
  fileID?: number;
  fileMimeType?: string;
  fileName?: string;
  filePath?: string;
  latestPublishedVersion?: number | null;
  partnerCompanyId?: string;
  partnerCompanyName?: string;
  publishedByUserFullName?: string | null;
  publishedOn?: string | null;
  referenceNumber?: string | null;
  releaseNotes?: string | null;
  requireApproval: boolean;
  requireEmailNotification: boolean;
  requireEmployeeAcknowledgement: boolean;
  requireEmployeeSignature: boolean;
  requireSignature: boolean;
  requireSignedCopy: boolean;
  retiredByUserFullName?: string | null;
  retiredOn?: string | null;
  retirementNotes?: string | null;
  statusId: number;
  statusName: string;
  supportWatchers: boolean;
  title: string;
  versionNumber?: number | null;
  questions?: string | null;
  type?: DocumentType;
  employmentTypes?: number[];
};

export type LetterParam = {
  assetID: string;
  versionNumber?: any;
};
